import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';

import { IconButtonComponent } from '../../../../popper/components/icon-button/icon-button.component';
import { IconButtonColorEnumPipe } from '../../../../popper/components/icon-button/icon-button-color-enum.pipe';

@Component({
    selector: 'open-delete-cell',
    templateUrl: './open-delete-cell.component.html',
    styleUrls: ['./open-delete-cell.component.scss'],
    standalone: true,
    imports: [IconButtonComponent, IconButtonColorEnumPipe]
})
export class OpenDeleteCellComponent implements OnInit, ICellRendererAngularComp {
    public data: any;
  public api: any;
  public rowIndex: number = -1;
  public readOnly: boolean = true;
  constructor(private router: Router) {
    console.log('opendeletecell constructed');
  }

  agInit(params: ICellRendererParams<any, any>): void {
    this.data = params.data;
    this.api = params.api;
    this.rowIndex = params.node.rowIndex;
    console.log('ag init', this.data)
  }
  refresh(params: ICellRendererParams<any, any>): boolean {
    this.rowIndex = params.node.rowIndex;
    return false;
  }

  ngOnInit(): void {
  }

  open(): void {
    this.router.navigate(['/disclosure/edit-disclosure/', this.data.disclosureId]);
  }

  delete(): void {
    if (this.api.onActionTrigger) {
      this.api.onActionTrigger({ row: this.rowIndex, action: "delete", data: this.data });
    } else {
      console.error("OnActionTrigger not defined");
    }
  }
}
